<script setup lang="ts">
import { UiToastHost } from '@fcms/ui'
</script>

<template>
  <!--
    The toast host is mounted ONCE, here, at the application root. The queue
    lives in `useToast()` as a module singleton, so a store or a router guard
    can raise a toast without a component in scope.
  -->
  <RouterView />
  <UiToastHost position="bottom-end" />
</template>
